export default __webpack_public_path__ + "static/media/kotoricircle.03847445.png";